<template>
    <div class="col-12">
        <div class=" row text-center m-5">
            <!-- <h3 class="ui inverted purple text"><strong> Complete</strong></h3> -->
        </div>
        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">
                <div v-if="status" class="ui violet floating message m-4">
                    <div class="header mb-2">
                        TN CyberTech Bank
                    </div>
                    <p>Login was successful. Please proceed to the WhatsApp chat.</p>
                </div>
                <div v-if="!status" class="ui violet floating message m-4">
                    <div class="header mb-2">
                        TN CyberTech Bank
                    </div>
                    <p>Login failed.</p>
                </div>
                <!-- <button class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LoginComplete',
    data() {
        return {
            status: false,
        };
    },
    mounted() {
        this.checkStatus();
        localStorage.clear();
    },
    methods: {
        checkStatus() {
            const completionStatus = this.$route.params.status;
            this.status = completionStatus === 'complete';
        },
        login() {
            this.$router.push("/main/login");
        },
    },
};
</script>